import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginAction } from '../redux/actions/authAction';
import background from '../assets/images/backgroundnew.png'

const Login = () => {
   
    const navigate = useNavigate();
    const dispatch= useDispatch()

  

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },

        validate: (data) => {
            let errors = {};

            if (!data.email) {
                errors.email = 'Email is required.';
            }
            if (!data.password) {
                errors.password = 'Password is required.';
            }

            return errors;
        },

        onSubmit: async (data) => {
            const res = await dispatch(loginAction(data));
        }
    });



    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="grid flex justify-content-center login__screen">
            <div className="col-6 image__section" style={{ height: '100vh', background: `url(${background})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }}>
                {/* <img src={logo} className="ml-4" /> */}
            </div>
            <div className="col-6 input_section_login">
                <div className=" pr-6 pl-6 pt-6 login__card">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="flex flex-column">
                            <div className="flex align-items-center justify-content-center my-5 logo-container">
                                <p className="Signin__Heading">Sign in to System</p>
                            </div>
                            <div className="form-container">
                                <div className="flex flex-column w-12">
                                    <label htmlFor="email" className={classNames({ 'p-erro': isFormFieldValid('email') }, 'Label__Text')}>
                                        Email <span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        id="email"
                                        className={classNames({ 'p-invalid': isFormFieldValid('email') }, 'Input__Round mb-0')}
                                        name="email"
                                        value={formik.values.email}
                                        placeholder="Enter Email"
                                        onChange={formik.handleChange}
                                        autoFocus
                                    />
                                    {getFormErrorMessage('email')}
                                </div>
                                <div className="flex flex-column w-12 mt-5">
                                    <label htmlFor="password" className={classNames({ 'p-erro': isFormFieldValid('password') }, 'Label__Text')}>
                                        Password <span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        className={classNames({ 'p-invalid': isFormFieldValid('password') }, 'Input__Round mb-0')}
                                        name="password"
                                        placeholder="Enter Password"
                                        value={formik.values.password}
                                        // onChange={formik.handleChange}
                                        onChange={(e) => {
                                            const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
                                            formik.setFieldValue('password', valueWithoutSpaces);
                                        }}
                                        type="password"
                                    />
                                    {getFormErrorMessage('password')}
                                </div>
                                {/* <div style={{ textAlign: 'right', marginTop: '5px' }} className='mt-4'>
                                    <a href="/forgot-password" style={{ color: 'red', textDecoration: 'none', fontSize: '1.2rem' }}>
                                        Forgot Password?
                                    </a>
                                </div> */}
                            </div>
                            <div className={`button-container flex justify-content-center align-items-center mt-8 mb-5`}>
                                <Button type="submit" label="Sign In" className={`Login__Button`} />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
